import { render, staticRenderFns } from "./DownloadPanel.vue?vue&type=template&id=560994ce&scoped=true"
import script from "./DownloadPanel.vue?vue&type=script&lang=ts"
export * from "./DownloadPanel.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./DownloadPanel.vue?vue&type=style&index=0&id=560994ce&prod&lang=less")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./DownloadPanel.vue?vue&type=style&index=1&id=560994ce&prod&scoped=true&lang=less")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "560994ce",
  null
  ,true
)

export default component.exports